const BarChart = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 6.5A1.5 1.5 0 0 1 14.5 8h-9A1.5 1.5 0 0 1 4 6.5v-1A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5zm-1.5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM18.5 14a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 4 11.5v1A1.5 1.5 0 0 0 5.5 14zm.5-1.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5zM10.5 20a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-5A1.5 1.5 0 0 0 4 17.5v1A1.5 1.5 0 0 0 5.5 20zm.5-1.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5z"
      clipRule="evenodd"
    />
  </>
)
export default BarChart
